export default from './Survey';



// WEBPACK FOOTER //
// ./src/components/SurveyPage/components/Survey/index.js